export const educationData = [
    {
        id: 1,
        title: "Engineer's Degree in Big Data and AI",
        where: "ENSA Khouribga, Morocco",
        when: "2021 - 2024",
    },
    {
        id: 2,
        title: "Computer Science",
        where: "1337 - 42 Network, Morocco",
        when: "2022 - 2023",
    },
    {
        id: 3,
        title: "Integrated Preparatory Classes",
        where: "ENSA Khouribga, Morocco",
        when: "2018 - 2021",
    },
    {
        id: 4,
        title: "Bacalaureat Mathematic Sciences",
        where: "Othmane Ibn Affane High School, Morocco",
        when: "2016 - 2018",
    },
];

export const experienceData = [
    {
        id: 1,
        title: "Data Scientist",
        where: "Oracle, Morocco",
        when: "Feb 2024 - Present",
    },
    {
        id: 2,
        title: "Data Engineer",
        where: "TrouveTaVoie, Paris, France",
        when: "Jun 2023 - Sep 2023",
    },
    {
        id: 3,
        title: "Technical Lead",
        where: "Dataverse, Khouribga, Morocco",
        when: "Oct 2022 - Jun 2023",
    },
    {
        id: 4,
        title: "Web Developer",
        where: "IID ENSA Khouribga, Morocco",
        when: "jul 2022 - Sep 2022",
    },
];